import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import {
  DkimStatus,
  DnsRecordCheckStatus,
  DnsRecordKind,
  MailFromDomainStatus,
} from "./domain-verification";

const dnsRecordCheckSchema = z.object({
  status: createEnum(DnsRecordCheckStatus, {
    enumName: "DnsRecordCheckStatus",
  }),
  lastCheckedAt: z.date().nullish(),
  lastChangedAt: z.date().nullish(),
  observed: z.string().nullish(),
});

export const emailDomainSchema = z.object({
  id: z.string(),
  domain: z.string(),
  mailFromDomain: z.string().nullish(),
  mailFromDomainStatus: createEnum(MailFromDomainStatus, {
    enumName: "MailFromDomainStatus",
  }).nullish(),
  dkimSelector: z.string(),
  dkimStatus: createEnum(DkimStatus, { enumName: "DkimStatus" }),
  dkimPrivateKey: z.string().nullish(),
  dnsLastVerifiedAt: z.date().nullish(),
  configurationSetTransactional: z.string().nullish(),
  configurationSetMarketing: z.string().nullish(),
});
export type EmailDomain = z.infer<typeof emailDomainSchema>;

export const dnsRecordStatusesSchema = z.object({
  [DnsRecordKind.DKIM]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.SPF]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.DMARC]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.MAIL_FROM_MX]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.MAIL_FROM_SPF]: dnsRecordCheckSchema.nullish(),
});

export const publicEmailDomainSchema = emailDomainSchema
  .omit({ dkimPrivateKey: true })
  .extend({
    dnsRecordStatuses: dnsRecordStatusesSchema,
    publicKey: z.string(),
  });
export type PublicEmailDomain = z.infer<typeof publicEmailDomainSchema>;
